"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.updateSagaContext = updateSagaContext;
var _effects = require("redux-saga/effects");
var actions = _interopRequireWildcard(require("../actions"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function* updateSagaContext(action) {
  try {
    const {
      config,
      locale
    } = action.payload;
    yield (0, _effects.setContext)({
      config,
      locale
    });
  } catch (error) {
    global.console.error('Error while updating config in saga context', error);
  }
}
function _default() {
  return (0, _effects.all)([(0, _effects.takeLatest)(actions.UPDATE_SAGA_CONTEXT, updateSagaContext)]);
}